
import "./components/common/LazyImg";
import Splide from '@splidejs/splide';
import "./components/exitintent/exitintent_popup";

/**
 * This is our clientside javascript entry point
 */

// The Ceres bundle provides Vue, we do not need to bundle it ourself
const Vue = window.Vue;
var initShopbuilderScripts = false;

$(document).on("shopbuilder.before.viewUpdate shopbuilder.after.viewUpdate", function(event, eventData, widgetElement)
{
    if(!initShopbuilderScripts){
        initShopbuilderScripts = true;
    }
    
});

window.homeSliderElement = null;
function initHomeSlider(withAutoplay){
    console.log(withAutoplay)
    console.log("withAutoplay")
    if(homeSliderElement != null){
        homeSliderElement.destroy();
    }

    
    var initHomeSlider = false;
    var homeSliderInterval = setInterval(function () {
        if($('.splide-slider').length > 0 && !initHomeSlider){         
            initHomeSlider = false;
            $('.splide-slider').each(function(){
                homeSliderElement = new Splide(this,{
                    mediaQuery: 'min',
                    type   : 'loop',
                    pagination: true,
                    arrows: false,
                    perPage: 1,
                    perMove: 1,
                    autoplay: withAutoplay,
                    speed: 1500,
                    reducedMotion: {
                        interval: 4000,
                        
                        autoplay: "play"
                    },
                    breakpoints:{
                        1200: {
                            arrows: true
                        },
                    }
                }).mount();
            })
            clearInterval(homeSliderInterval); 
        }
    }, 100);
}
$(document).ready(function(){

    if(!vueApp.$ceres.isShopBuilder){
        initHomeSlider(true);
    }
    
})
$(document).on("shopbuilder.after.drop shopbuilder.after.widget_replace", function(event, eventData, widgetElement)
{
   if($(widgetElement).hasClass('splide-slider')){
        initHomeSlider(false);
   }
});

const cartClass = "fa-shopping-cart";
const loadingClass = "fa-spin fa-circle-o-notch";

document.addEventListener("afterBasketItemAdded", function(response){
    console.log("LOIKSDJFLKDJ")
    vueApp.$store.dispatch("loadComponent", "basket-preview");
    var dataToAdd = [];
    
    $('.acc-rp-check').each(function(){

        if($(this).is(':checked')){
            const data = {
                variationId : $(this).data('variationid'),
                quantity    : 1,
                basketItemOrderParams: null,
                totalOrderParamsMarkup: null
            };
            dataToAdd.push(data);
        }
    });
    if(dataToAdd.length>0){
        var $addBasketBtn = $('.add-to-basket-container > .btn');
        /*
         * Check if loading class is on button and add it
         */
        const loadInterval = setInterval(function(){
            if(!$addBasketBtn.find('.fa').hasClass('fa-circle-o-notch')){
                $addBasketBtn.attr('disabled','disabled');
                $addBasketBtn.find('.fa').removeClass(cartClass);
                $addBasketBtn.find('.fa').addClass(loadingClass);
                clearInterval(loadInterval);
            }
        }, 10);
        
        const requestAdd = [];
        requestAdd.push(addItemBasket(dataToAdd));
        
        $.when.apply($, requestAdd).done(function(){
              
                //document.body.classList.toggle("basket-open");
                $addBasketBtn.removeAttr('disabled');
                $addBasketBtn.find('.fa').removeClass(loadingClass);
                $addBasketBtn.find('.fa').addClass(cartClass);
            
            
        });
    }
    
    /*else{
        document.body.classList.toggle("basket-open");
    }*/
})

async function addItemBasket(basketItemData){
    for (const basketData of basketItemData) {
        await vueApp.$store.dispatch("addBasketItem", basketData);
    }   
}

function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
}

function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
}

document.addEventListener("scroll", () => {
    if (window.scrollY > 800 && !getCookie("showModal")) {
        $('.modal-nl').modal();
        setCookie("showModal", "false", 7);
    }
});
